import BaseContent from "../base.content";
import {TYPE_RICH_TEXT_CONTENT} from "../constants";
import {CMSContentType} from "../CMSType";
import {AContentParams} from "../base.content";
import {AContentDTO} from "../base.content";

export interface RichTextContentDTO extends AContentDTO {
  body: string;
}

export interface RichTextContentParams {
  body: string;
}

export class RichTextContent extends BaseContent {
  readonly body: string;

  setBody(body: string): this {
    return this._merge({body});
  }

  constructor(params: RichTextContentParams = {body: ''}) {
    super(CMSContentType.richText);
    this.body = params.body;
  }

  public toJSON() {
    return Object.assign(super.toJSON(), {
      body: this.body
    });
  }
}

export default RichTextContent;



// WEBPACK FOOTER //
// ./src/api/club-cms/content/rich-text.content.ts